module.exports = __webpack_public_path__ + "img/paiqishan.cd059c45.png";